import { PacksList } from './Packages.styled';
import PackItem from './PackItem';

export default function PackList({ packages, promoApplied, onBuy, rubPrices }) {
	return (
		<PacksList>
			{packages && packages.map((pack, idx) => (
				<PackItem
					key={pack.id}
					pack={pack}
					promoApplied={promoApplied}
					onBuy={onBuy}
					rubPrice={rubPrices[idx]}
				/>
			))}
		</PacksList>
	);
} 